
import { ChevronDown, Columns3, Ellipsis, Layers3, List, Maximize2, Minimize2, Rows3, Table, X } from 'lucide-react';
import assert from 'assert';
import { FieldType } from 'bindings/forms/FieldType';
import deleteImage from 'images/icon/delete.png';
import close from 'images/icons/orders/close.svg';
import { isArray } from 'lodash';
import moment from 'moment';
import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';
import readXlsxFile from 'read-excel-file';
import { useRecoilState, useRecoilValue } from 'recoil';
import styled from 'styled-components';
import { validate } from 'uuid';
import * as XLSX from 'xlsx';
import { AColors } from '../../atoms/colors/colors';
import { ABrandFilter, AEmptyBrand } from '../../atoms/filter/BrandFiltersAtom';
import { AInputSearch } from '../../atoms/filter/InputSearchFilter';
import { AProductFilter } from '../../atoms/filter/productsFilterAtom';
import { AFormFields, Field } from '../../atoms/forms';
import { AProducts, Product } from '../../atoms/product';
import { AtomCategory } from '../../atoms/utils/model/Model';
import Add from '../../components_v2/add/Add';
import Dropdown from '../../components_v2/dropdown/Dropdown';
import Dropdown2 from '../../components_v2/dropdown/Dropdown2';
import { DropdownData } from '../../components_v2/dropdown/model/Model';
import { CleanButton } from '../../components_v2/dropdown/style/Style';
import { PopupMode } from '../../components_v2/popup/model/Model';
import Popup from '../../components_v2/popup/Popup';
import { ButtonStyle } from '../../components_v2/popup/PopupCreation';
import Switch from '../../components_v2/Switch/Switch';
import { InfiniteTable, InfiniteTableStyle } from '../../components_v2/table/InfiniteTable';
import { getLocalStorage, setLocalStorage } from '../../helpers/localStorage';
import { Column, DataType } from '../../components_v2/table/Table';
import ToolbarFilter, { ToolbarElement } from '../../components_v2/toolbarFilter/ToolbarFilter';
import { getWindowDimensions } from '../../components_v2/utils';
import { Dot } from '../../styles/global/css/Dot';
import { DefaultButton } from '../../styles/global/css/GlobalButton';
import { DefaultImage } from '../../styles/global/css/GlobalImage';
import { Loader } from '../../styles/global/css/GlobalLoader';
import { PrimaryColor, BackgroundColor, BorderColor, DarkGreySidely2, GreySidely3, PastelPrimaryColor, SidelyBlack, SurfaceColor } from '../../styles/global/css/Utils';
import { Translate, translateToString } from '../../styles/global/translate';
import { useClampToViewport, useFunctionState, useRefState } from '../../utils/customHooks';
import { RawFieldEditor } from '../../utils/fieldEditor';
import useAlert from '../alert/UseAlert';
import { Delete } from '../client-companies/style/NewPhotoStyle';
import { creationPopupDropdownStyle } from '../../components_v2/popup/style/CreationFormStyle';
import { BoolCheckbox } from '../forms/PopupField';
import { launchToastError, launchToastMessage } from '../forms/visual-form-editor/visualFormEditor';
import { TOOLBARS_HEIGHT, ToolbarBox, ToolbarImageContainer } from '../globals/defaultToolbar/style/Style';
import { ComponentProps } from '../globals/mainPage/mainPage';
import { LoadingStateEnum } from '../import/model';
import { getBase64 } from '../import/UploadFile';
import { ModalLeftToggle } from '../map/modalLeft/ModalLeftFilter';
import PageSwitch from '../map/PageSwitch';
import NoData from '../noData/NoData';
import { ComponentLoader } from '../map/modalRight/ModalCalendar';
import { TableRow, TableRowTitle } from '../orders/templateOrders/style/Style';
import { InlineButton, OnFocusInputContainer } from '../reports/interpretor/ReportInterpretor';
import { deleteAdditionalValues, getAdditionalValues, getAdditionalValuesViews, importAdditionalValues, refreshThericalPresence, saveAdditionalValue } from './action';
import AssortmentFieldPage, { AdditionalValuesView, DimensionValue } from './assortmentFieldPage';
import AssortmentModalLeft, { MODAL_LEFT_WIDTH } from './assortmentModalLeft';
import { AdditionalValuesPath, getAdditionalValuesPaths } from '../settings/subSettings/actions';
import { ModalState } from './model';
import importMultiDimensionalAssortments from './multiDimentionalAssortments/import';
import ProductPopup, { BarcodeWrapper } from './product';
import { FlexDiv } from './style';

type InnerColumnType = { product: Product, field?: Field, values: Record<string, unknown>, comparaisonsValues: unknown[], oneColCellValue?: unknown, dotColor?: string, comparaisonIndex?: number, mainRow?: InnerColumnType, fieldToShow?: Field, staticValues?: Record<string | number, unknown> };
type ColumnType = Column<InnerColumnType>;
export type AdditionalValue = [Record<any, any>, any];
type StaticValues = Record<string | number, unknown>;

export type PathAndValue = {
	path: AdditionalValue[0],
	value: AdditionalValue[1]
}

export type ValuesToDelete = {
	id: string,
	values: string[]
} | undefined;

type BuidPathOptions = {
	product?: string,
	staticValues?: Record<string | number, unknown>,
	chosenField?: { id: number, value: unknown },
	f?: unknown
}

const DOTSIZE = '16px';

function buildCellPath(opt: BuidPathOptions) {
	const path = {};
	if (opt.product) path['p'] = opt.product;
	if (opt.chosenField) path[opt.chosenField.id] = opt.chosenField.value;
	if (opt.f) path['f'] = opt.f;
	return { ...path, ...opt.staticValues };
}

function findAdditionalValueRef(path: Record<string | number, unknown>, values: AdditionalValue[]): AdditionalValue | undefined {
	return values.find(([key]) => {
		if (Object.keys(key).length !== Object.keys(path).length) return false;
		for (const k in path) {
			if (key[k] !== path[k]) return false;
		}
		return true;
	});

}

const Select = styled.select<{ border?: boolean }>`
	${({ border }) => border ? '' : ' border: none; width: 100%;'}
	font-size: 12px;
	font-weight: 400;
	color: ${DarkGreySidely2};
`;

const SwitchText = styled.p`
	margin: 0;
	padding-inline: 8px;
	white-space: nowrap;
`;

const DimensionButton = styled.button<{ backgroundColor?: string }>`
	display: flex;
	align-items: center;
	gap: 4px;
	height: 26px;
	padding: 0 5px;
	border: none;
	border-radius: 5px;
	background-color: ${p => p.backgroundColor ?? 'transparent'};
	color: ${DarkGreySidely2};
	font-size: 12px;
	cursor: pointer;
`;

const DimensionSizer = styled.span`
	display: grid;
	text-align: left;
	white-space: nowrap;
	& > * {
		grid-area: 1 / 1;
	}
`;

const DimensionGhost = styled.span`
	visibility: hidden;
`;

const DimensionOptions = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5px;
	max-height: 300px;
	overflow-y: auto;
`;

const DimensionOption = styled.div<{ selected?: boolean }>`
	padding: 4px 8px;
	border-radius: 4px;
	font-size: 12px;
	white-space: nowrap;
	cursor: pointer;
	font-weight: ${p => p.selected ? 500 : 400};
	&:hover {
		background-color: ${BackgroundColor};
	}
`;

const ChipDelimiter = styled.div`
	width: 1px;
	height: 16px;
	background-color: ${BorderColor};
`;

const FILTER_HEIGHT = 40;
const FILTER_HEIGHT_S = `${FILTER_HEIGHT}px`;

const BaseDropdownStyle = { ...creationPopupDropdownStyle, containerBorder: 'none', height: FILTER_HEIGHT_S };
const DropdownStyle = { ...BaseDropdownStyle, height: '26px', inputMargin: '0 5px', inputPadding: '0 5px' };
const HeaderDropdownStyle = { ...BaseDropdownStyle, height: '30px' };

const LocalButton = styled(DefaultButton)`
	margin: 0;
`;

const RoundButton = styled.div`
	position: absolute;
	right: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${SurfaceColor};
	min-width: 32px;
	width: 32px;
	aspect-ratio: 1;
	border-radius: 16px;
	cursor: pointer;
	box-shadow: 0px 1px 2px lightgrey;
`;

type FieldFilters = { field?: Field, fieldValue?: unknown }[];

function sameDimensions(path: AdditionalValuesPath, dimensionIds: (number | undefined)[]): boolean {
	return path.additional_column_ids.length === dimensionIds.length && path.additional_column_ids.every((id, index) => id === dimensionIds[index]);
}

function nextComparaisonColor(colors: { colorCode: string }[], used: string[]): string | undefined {
	const usedLower = used.map(color => color.toLowerCase());
	const available = colors.filter(color => !usedLower.includes(color.colorCode.toLowerCase()));
	return (available[(usedLower.length + 4) % available.length] ?? available[0])?.colorCode;
}

function comparaisonHighlight(color: string): string {
	return `color-mix(in oklab, ${color} 10%, white)`;
}

function DimensionSelect(props: { options: string[], value: unknown, onChange: (value: string | undefined) => void, backgroundColor?: string }) {
	const label = typeof props.value === 'string' ? props.value : undefined;
	return <Dropdown2
		button={({ setIsOpen }) => <DimensionButton type='button' backgroundColor={props.backgroundColor} onClick={() => setIsOpen(open => !open)}>
			<DimensionSizer>
				{props.options.map(option => <DimensionGhost key={option}>{option}</DimensionGhost>)}
				<span>{label}</span>
			</DimensionSizer>
			{label && <X size={12} onClick={e => {
				e.stopPropagation();
				props.onChange(undefined);
			}} />}
			<ChevronDown size={14} />
		</DimensionButton>}
	>
		{({ setIsOpen }) => <DimensionOptions>
			{props.options.map(option => <DimensionOption key={option} selected={option === label} onClick={() => {
				setIsOpen(false);
				props.onChange(option);
			}}>{option}</DimensionOption>)}
		</DimensionOptions>}
	</Dropdown2>;
}

function isEmptyValue(value: unknown): boolean {
	return value == null || value === '';
}

function staticValuesFromFilters(filters: FieldFilters): StaticValues {
	return filters.reduce<StaticValues>((acc, { field, fieldValue }) => {
		if (!field || !fieldValue) return acc;
		acc[field.id] = fieldValue;
		return acc;
	}, {});
}

// Canonical cell key. Order-insensitive like the JSON.stringify(sorted
// entries) it replaces, but ~10x cheaper: no tuple allocation, no JSON
// escaping. The typeof tag keeps "1" and 1 distinct, as JSON did. Called
// once per cell per grid build, so it is the hottest function of the page.
function pathKey(obj: Record<string | number, unknown>): string {
	const keys = Object.keys(obj);
	if (keys.length > 1) keys.sort();
	let out = '';
	for (const key of keys) {
		const value = obj[key];
		out += key + '\u0001' + typeof value + '\u0002' + String(value) + '\u0003';
	}
	return out;
}

function updateBulkEditAndAdditionnalValues(additionalValues: AdditionalValue[], pathAndValues: PathAndValue[], setLoadingState: React.Dispatch<React.SetStateAction<LoadingStateEnum>>, setAdditionalValues?: React.Dispatch<React.SetStateAction<AdditionalValue[]>>) {
	importAdditionalValues(pathAndValues).then(() => {
		setLoadingState(LoadingStateEnum.LOADED);
		const newAdditionalValues = additionalValues ? [...additionalValues] : [];
		pathAndValues.forEach(({ path, value }) => {
			const ref = findAdditionalValueRef(path, newAdditionalValues);
			if (ref) ref[1] = value;
			else newAdditionalValues.push([path, value]);
		});
		setAdditionalValues?.(newAdditionalValues);
	}
	).catch(() => setLoadingState(LoadingStateEnum.ERROR));
}

function getPathAndValuesEditCol(ignoreNonEmpty: boolean, inputValue: any, staticValues: StaticValues, p: DataType<InnerColumnType>, data: React.MutableRefObject<InnerColumnType[]>, setLoadingState: React.Dispatch<React.SetStateAction<LoadingStateEnum>>, valuesMap: Map<string, unknown>, fieldId: number, value?: string): PathAndValue[] | null {
	let valueToSet = inputValue;
	const staticValuesFull = value ? { ...staticValues, [fieldId]: value, f: p.field?.id } : { ...staticValues, f: fieldId };
	if (valueToSet === undefined) valueToSet = null;
	const path = buildCellPath({ product: p.product.uuid, staticValues: staticValuesFull });
	if (!data || !data.current) return null;
	setLoadingState(LoadingStateEnum.LOADING);
	const productsUuids = data.current.map(p => p.product.uuid);
	const indexToStart = productsUuids.indexOf(path['p']);
	if (indexToStart === -1) return null;
	return ignoreNonEmpty ? buildEditColumnEmptyArray(path, valueToSet, productsUuids.slice(indexToStart), valuesMap) : buildEditColumnArray(path, valueToSet, productsUuids.slice(indexToStart));
}

function getPathAndValuesEditRow(ignoreNonEmpty: boolean, inputValue: any, staticValues: StaticValues, fieldToShow: Field, value: string, p: DataType<InnerColumnType>, allowedValues: any[] | undefined, setLoadingState: React.Dispatch<React.SetStateAction<LoadingStateEnum>>, valuesMap: Map<string, unknown>): PathAndValue[] | null {
	let valueToSet = inputValue;
	if (valueToSet === undefined) valueToSet = null;
	const staticValuesFull = { ...staticValues, [fieldToShow.id]: value, f: p.field?.id };
	const path = buildCellPath({ product: p.product.uuid, staticValues: staticValuesFull });
	if (!fieldToShow || !fieldToShow.data || !isArray(fieldToShow.data)) return null;
	setLoadingState(LoadingStateEnum.LOADING);
	let indexToStart = -1;
	let cols = fieldToShow.data;
	if (allowedValues) {
		indexToStart = allowedValues.indexOf(staticValuesFull[fieldToShow.id] as string);
		cols = allowedValues.slice(indexToStart);
	}
	else {
		indexToStart = fieldToShow.data.indexOf(staticValuesFull[fieldToShow.id] as string);
		cols = fieldToShow.data.slice(indexToStart);
	}
	if (indexToStart === -1) return null;
	return ignoreNonEmpty ? buildEditRowEmptyArray(path, valueToSet, cols, fieldToShow.id.toString(), valuesMap) : buildEditRowArray(path, valueToSet, cols, fieldToShow.id.toString());
}

const AdditionnalValueStyle = styled.div<{ justify?: 'center' | 'left' | 'right' }>`
	width: 100%;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	text-align: ${p => p.justify ?? 'center'};
`;

const sortCol = (colName: string, singleColumn: boolean) => (rowA: InnerColumnType, rowB: InnerColumnType, desc: boolean) => {
	if (rowA.product.uuid === rowB.product.uuid) {
		if (rowA.comparaisonIndex == null || rowB.comparaisonIndex == null) return 0;
		if (rowA.comparaisonIndex > rowB.comparaisonIndex) return 1;
		return -1;
	}
	const additionalValueA = singleColumn ? rowA.oneColCellValue : rowA.mainRow ? rowA.mainRow.values[colName] : rowA.values[colName];
	const additionalValueB = singleColumn ? rowB.oneColCellValue : rowB.mainRow ? rowB.mainRow.values[colName] : rowB.values[colName];

	const isAEmpty = additionalValueA === undefined || additionalValueA === null;
	const isBEmpty = additionalValueB === undefined || additionalValueB === null;
	if (isAEmpty && !isBEmpty) return 1;
	if (!isAEmpty && isBEmpty) return -1;
	if (isAEmpty && isBEmpty) return 0;
	if (additionalValueA == null || additionalValueB == null)
		return 0;

	if (typeof additionalValueA === 'number' && typeof additionalValueB === 'number') {
		return desc ? additionalValueB - additionalValueA : additionalValueA - additionalValueB;
	}
	return desc ? additionalValueB.toString().localeCompare(additionalValueA.toString()) : additionalValueA.toString().localeCompare(additionalValueB.toString());
};

type ExportDropdownDataByField = { field: Field, dataList: DropdownData<{ fieldId: number, value: string }>[] }[];

// The values a constrained field may take given the pinned dimension values,
// or undefined when nothing constrains it. Mirrors the page's allowedValues
// memo but skips (rather than throws on) non-string pins so exports and
// imports can evaluate arbitrary combinations.
type ConstraintMap = Record<string, Record<string, string[]>>;

function intersectAllowed(acc: string[] | undefined, allowed: string[]): string[] {
	return acc === undefined ? allowed : acc.filter(v => allowed.includes(v));
}

function constraintAllowedValues(field: Field, staticValues: StaticValues, pinnedFields: Field[] = []): string[] | undefined {
	let acc = Object.entries((field.constraint ?? {}) as ConstraintMap).reduce<string[] | undefined>((acc, [constraintField, constraintMap]) => {
		const pinned = staticValues[constraintField];
		if (typeof pinned !== 'string') return acc;
		const allowed = constraintMap[pinned];
		if (!allowed) return acc;
		return intersectAllowed(acc, allowed);
	}, undefined);
	for (const other of pinnedFields) {
		if (other.id === field.id) continue;
		const pinned = staticValues[other.id];
		const reverse = (other.constraint as ConstraintMap | undefined)?.[field.id];
		if (typeof pinned !== 'string' || !reverse) continue;
		const candidates = Array.isArray(field.data) ? field.data as string[] : Object.keys(reverse);
		acc = intersectAllowed(acc, candidates.filter(v => !reverse[v] || reverse[v].includes(pinned)));
	}
	return acc;
}

function pinnedFieldsOf(filters: FieldFilters): Field[] {
	return filters.flatMap(filter => filter.field ? [filter.field] : []);
}

function getExportDropDownDataByField(additionalFieldsFilters: FieldFilters): ExportDropdownDataByField {
	const res: ExportDropdownDataByField = [];
	for (const field of additionalFieldsFilters) {
		if (!field.field || !field.field.data || !isArray(field.field.data)) continue;
		const dataList: DropdownData<{ fieldId: number, value: string }>[] = field.field.data.map(value => ({
			checked: field.fieldValue === value,
			label: value.toString(),
			value: { fieldId: field.field.id, value },
		}));
		res.push({ field: field.field, dataList });
	}
	return res;
}

async function exportAssortments(fieldToSet: Field | undefined, fieldToShow: Field | undefined, additionalFieldsFilters: FieldFilters, data: React.MutableRefObject<InnerColumnType[]>, exportProducts: Product[], filterEmptyRows: boolean, allowedValues: any[] | undefined, staticValues: StaticValues = {}, additionalValuesHashMap: Map<string, any>) {
	function getAllStaticValuesCombinations(filters: FieldFilters): Record<string | number, unknown>[] {
		const filter = filters.pop();
		if (filter === undefined) return [];
		if (filter.field === undefined) return getAllStaticValuesCombinations(filters);
		if (filter.fieldValue === '') {
			const res: Record<string | number, unknown>[] = [];
			if (!isArray(filter.field.data) || filter.field.data.length === 0) return [...getAllStaticValuesCombinations(filters)];
			for (const data of filter.field.data) {
				const newStaticValues = { [filter.field.id]: data };
				const nestedResults = getAllStaticValuesCombinations([...filters]);
				if (nestedResults.length === 0) {
					res.push(newStaticValues);
				} else {
					for (const nested of nestedResults) {
						res.push({ ...newStaticValues, ...nested });
					}
				}
			}
			return res;
		} else {
			const newStaticValues = { [filter.field.id]: filter.fieldValue };
			const nestedResults = getAllStaticValuesCombinations([...filters]);
			if (nestedResults.length === 0) {
				return [newStaticValues];
			} else {
				return nestedResults.map(nested => ({ ...newStaticValues, ...nested }));
			}
		}
	}

	if (!fieldToSet || !data.current) return;
	function valueToCell(value: any, field?: Field) {
		if (!field)
			return { t: 's', v: value?.toString() ?? '' };
		switch (field.type) {
			case 'Money':
				return { t: 'n', v: value / 100 };
			case 'Number':
				return { t: 'n', v: value, z: '0.00' };
			case 'Integer':
				return { t: 'n', v: value };
			case 'Date':
				return { t: 'd', v: moment.unix(value).toDate() };
			case 'Boolean':
				return { t: 'b', v: value };
			default:
				return { t: 's', v: value };
		}
	}
	let headers = [{ t: 's', v: 'Products' }, { t: 's', v: 'Barcode' }];
	let rows: (unknown[] | undefined)[] = [];
	let fileTitle = 'Export-assortments';
	if (!fieldToShow) {
		fileTitle = `Export-assortments-${fieldToSet.name}-${moment().format('YYYY-MM-DD_HH-mm')}.xlsx`;
		headers = [...headers, { t: 's', v: fieldToSet.name }];
		rows = data.current.map(p => {
			const additionalValue = p.oneColCellValue;
			if (filterEmptyRows && additionalValue == null) return undefined;
			return [p.product.name, p.product.barcode, valueToCell(additionalValue, p.field ?? fieldToSet)];
		});
	}
	else {
		const hasWildCard = additionalFieldsFilters.some(f => f.fieldValue === '');
		const additionalFiltersNames = additionalFieldsFilters.map(f => f.fieldValue).join('-');
		// One authoritative order for the dimension columns, headers and cells
		// alike. The combination objects key by field id and js iterates
		// integer-like keys numerically, so several dimensions exported their
		// values under each other's headers; a filter row without a field
		// emitted a header but no cell, shifting every column after it.
		const dimensionFilters = additionalFieldsFilters.filter(f => f.field !== undefined);
		fileTitle = `Export-assortments-${fieldToSet.name}-${fieldToShow.name}-${additionalFiltersNames}-${moment().format('YYYY-MM-DD_HH-mm')}.xlsx`;
		headers = [...headers, { t: 's', v: fieldToShow.name }, dimensionFilters.map(f => ({ t: 's', v: f.field!.name })), { t: 's', v: fieldToSet.name }].flat();
		if (hasWildCard) {
			// Field constraints prune the cartesian product: a combination
			// pinning incompatible dimension values, or a fieldToShow value
			// outside a combination's allowed set, can hold no data and would
			// only inflate the file.
			const combos = getAllStaticValuesCombinations(additionalFieldsFilters).filter(sv => {
				const merged = { ...staticValues, ...sv };
				return additionalFieldsFilters.every(f => {
					if (!f.field || merged[f.field.id] === undefined) return true;
					const allowed = constraintAllowedValues(f.field, merged, pinnedFieldsOf(additionalFieldsFilters));
					return !allowed || allowed.includes(merged[f.field.id] as string);
				});
			}).map(sv => {
				const allowed = constraintAllowedValues(fieldToShow, { ...staticValues, ...sv }, pinnedFieldsOf(additionalFieldsFilters));
				return {
					sv,
					values: (fieldToShow.data as string[]).filter(v => (!allowedValues || allowedValues.includes(v)) && (!allowed || allowed.includes(v))),
				};
			});
			rows = exportProducts.flatMap(product => {
				return combos.flatMap(({ sv, values }) => {
					return values.reduce((acc: unknown[][], value) => {
						const newStaticValues = { ...staticValues, ...sv, f: fieldToSet.id };
						if (fieldToShow) newStaticValues[fieldToShow.id] = value;
						const path = buildCellPath({ product: product.uuid, staticValues: newStaticValues });
						const additionalValue = additionalValuesHashMap.get(pathKey(path));
						if (filterEmptyRows && additionalValue == null) return acc;
						acc.push([product.name, product.barcode, value, ...dimensionFilters.map(f => sv[f.field!.id] ?? ''), valueToCell(additionalValue, fieldToSet)]);
						return acc;
					}, []);
				});
			});
		}
		else {
			rows = data.current.flatMap(p => {
				return (fieldToShow.data as string[]).filter(f => !allowedValues || allowedValues.includes(f)).map(value => {
					if (p.values[value] == null && filterEmptyRows) return undefined;
					return [p.product.name, p.product.barcode, value, ...dimensionFilters.map(f => f.fieldValue), valueToCell(p.values[value], p.field)];
				});
			});
		}
	}

	const wb = XLSX.utils.book_new();
	wb.Props = {
		Title: 'Assortments',
		Subject: 'Exported assortments',
		Author: 'Sidely',
		CreatedDate: new Date()
	};

	const wsData = [headers, ...rows];
	const ws = XLSX.utils.aoa_to_sheet(wsData.filter(row => row !== undefined));

	XLSX.utils.book_append_sheet(wb, ws, 'Products');
	XLSX.writeFileXLSX(wb, fileTitle, { bookType: 'xlsx', type: 'binary' });
}

const HeaderContainer = styled.div`
	padding-inline: 10px;
`;

type AssortmentViewMode = 'table' | 'list';

export default function AssortmentListingV3(props: ComponentProps) {
	const { height } = getWindowDimensions();
	const alert = useAlert();
	const [inputSearchText, setInputSearchText] = useRecoilState(AInputSearch);
	const colors = useRecoilValue(AColors);
	const products = useRecoilValue(AProducts);
	const [sortedProducts, setSortedProducts] = React.useState<Product[]>(() => [...products].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())));
	const fields = useRecoilValue(AFormFields);
	const [loadingState, setLoadingState] = React.useState<LoadingStateEnum>(LoadingStateEnum.LOADED);
	const [additionalFieldsFilters, setAdditionalFieldsFilters] = React.useState<FieldFilters>([]);
	const staticValues = React.useMemo<StaticValues>(() => staticValuesFromFilters(additionalFieldsFilters), [additionalFieldsFilters]);
	const [productPopupState, setProductPopupState] = React.useState<ModalState<number>>({ isOpen: false });
	const [additionalValues, setAdditionalValues] = React.useState<AdditionalValue[]>([]);
	const [colComparaisons, setColComparaisons] = React.useState<{ color: string, id: number, fieldToSet?: Field, filterEmptyRows: boolean }[]>([]);
	const [rowComparaisons, setRowComparaisons] = React.useState<{ filters: FieldFilters, color: string, id: number, fieldToSet: Field, fieldToShow: Field, staticValues: StaticValues, filterEmptyRows: boolean }[]>([]);
	const isOneRowComparaisonFilterEmpty = rowComparaisons.some(rc => rc.filterEmptyRows);
	const [colorsUsedForComparaisons, setColorsUsedForComparaisons] = React.useState<string[]>([PrimaryColor]);
	const [showComparaisons, setShowComparaisons] = React.useState(true);
	const [viewMode, setViewMode] = React.useState<AssortmentViewMode>('list');
	const [modalOpenByView, setModalOpenByView] = React.useState<Record<AssortmentViewMode, boolean>>({ table: false, list: true });
	const isModalOpen = modalOpenByView[viewMode];
	const [openedPathId, setOpenedPathId] = React.useState<number>();
	const [views, setViews] = React.useState<AdditionalValuesView[]>([]);
	const [viewsLoading, setViewsLoading] = React.useState(true);
	const [paths, setPaths] = React.useState<AdditionalValuesPath[]>([]);
	const brandFilter = useRecoilValue(ABrandFilter);
	const emptyBrand = useRecoilValue(AEmptyBrand);
	const productFilter = useRecoilValue(AProductFilter);
	const [filterEmptyRows, setFilterEmptyRows] = React.useState(false);
	const [popupOpen, setPopupOpen] = React.useState(false);
	const [popupHeight, setPopupHeight] = React.useState(300);
	const [warningDelete, setWarningDelete] = React.useState(false);
	const [pathToDelete, setPathToDelete] = React.useState({});
	const [pathMessage, setPathMessage] = React.useState('');
	const [pinnedUntil, setPinnedUntil] = React.useState<number>(() => getLocalStorage<number>('assortment_pinned_columns') ?? 2);
	const pinColumnsUntil = React.useCallback((count: number) => {
		setPinnedUntil(count);
		setLocalStorage('assortment_pinned_columns', count);
	}, []);
	const localStorageNameColWidth = React.useMemo(() => {
		const stored = localStorage.getItem('infinite_table_resize');
		return stored ? JSON.parse(stored).name : null;
	}, []);
	const fieldsMap = React.useMemo<Map<number, Field>>(() => fields.reduce<Map<number, Field>>((acc, field) => {
		acc.set(field.id, field);
		return acc;
	}, new Map()), [fields]);
	const additionalValuesHashMap = React.useMemo(() => {
		const res = new Map<string, any>();
		for (const [path, value] of additionalValues) {
			res.set(pathKey(path), value);
		}
		return res;
	}, [additionalValues]);
	// The bulk-edit handlers inside the columns read the value store through
	// refs: columns must NOT be rebuilt on every cell edit, only when the
	// table shape changes.
	const additionalValuesRef = React.useRef(additionalValues);
	additionalValuesRef.current = additionalValues;
	const additionalValuesHashMapRef = React.useRef(additionalValuesHashMap);
	additionalValuesHashMapRef.current = additionalValuesHashMap;
	const [data, setData, dataValue] = useRefState<InnerColumnType[]>([]);
	const [openEditExport, setOpenEditExport] = React.useState(false);
	const [confirmExport, setConfirmExport] = React.useState(false);
	const [toolbarOptions, setToolbarOptions] = React.useState<DropdownData[]>([]);

	const [exportDataFiltersList, setExportDataFiltersList] = React.useState<ExportDropdownDataByField>(getExportDropDownDataByField(additionalFieldsFilters));

	const [fieldToShow, setFieldToShow] = useFunctionState<Field | undefined>(undefined, ({ newValue }) => {
		if (!newValue) return undefined;
		setAdditionalFieldsFilters(t => {
			if (t.some(t => !t.field?.id)) return t;
			return t.filter(t => t.field?.id != newValue?.id);
		});
		return newValue;
	});
	const [fieldToSet, setFieldToSet] = useFunctionState<Field | undefined>(undefined, ({ newValue }) => {
		if (!newValue) return undefined;
		setFieldToShow(fts => {
			if (fts && fts.id == newValue?.id) return undefined;
			return fts;
		});
		setAdditionalFieldsFilters(t => {
			if (t.some(t => !t.field?.id)) return t;
			return t.filter(t => t.field?.id != newValue?.id);
		});
		return newValue;
	});

	React.useEffect(() => {
		setExportDataFiltersList(getExportDropDownDataByField(additionalFieldsFilters));
	}, [additionalFieldsFilters]);

	React.useEffect(() => {
		setSortedProducts([...products].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())));
	}, [products, productFilter]);

	React.useEffect(() => {
		getAdditionalValuesPaths().then(setPaths).catch(console.error);
		getAdditionalValuesViews().then(setViews).catch(console.error).finally(() => setViewsLoading(false));
	}, []);

	const pathOptions: DropdownData<AdditionalValuesPath>[] = React.useMemo(() => paths.map(path => ({ label: path.label, value: path })), [paths]);
	const findPathOption = React.useCallback((set: Field | undefined, show: Field | undefined, filters: FieldFilters) => {
		if (!set || !show) return undefined;
		const dimensionIds = [...filters.map(filter => filter.field?.id), show.id];
		return pathOptions.find(({ value }) => value.field_id === set.id && sameDimensions(value, dimensionIds));
	}, [pathOptions]);
	const resolvePath = React.useCallback((path: AdditionalValuesPath) => {
		const dimensions = path.additional_column_ids.map(id => fieldsMap.get(id)).filter((field): field is Field => field !== undefined);
		return {
			fieldToSet: fieldsMap.get(path.field_id),
			fieldToShow: dimensions[dimensions.length - 1],
			filters: dimensions.slice(0, -1).map(field => ({ field, fieldValue: undefined })),
		};
	}, [fieldsMap]);
	const selectedPath = React.useMemo(() => findPathOption(fieldToSet, fieldToShow, additionalFieldsFilters), [findPathOption, fieldToSet, fieldToShow, additionalFieldsFilters]);
	const openedPath = React.useMemo(() => viewMode === 'list' ? paths.find(path => path.id === openedPathId) ?? paths[0] : undefined, [viewMode, paths, openedPathId]);
	const isGroupingView = viewMode === 'list';
	const previousViewRef = React.useRef(isGroupingView);
	React.useEffect(() => {
		if (previousViewRef.current === isGroupingView) return;
		previousViewRef.current = isGroupingView;
		setInputSearchText('');
		if (!isGroupingView) return;
		setColComparaisons([]);
		setRowComparaisons([]);
		setColorsUsedForComparaisons([PrimaryColor]);
	}, [isGroupingView]);
	const applyPath = React.useCallback((path: AdditionalValuesPath | null) => {
		if (!path) {
			setFieldToSet(undefined);
			setFieldToShow(undefined);
			setAdditionalFieldsFilters([]);
			return;
		}
		const resolved = resolvePath(path);
		setFieldToSet(resolved.fieldToSet);
		setFieldToShow(resolved.fieldToShow);
		setAdditionalFieldsFilters(resolved.filters);
	}, [resolvePath]);
	const rowPathOptions = React.useMemo(() => {
		if (!fieldToSet || !fieldToShow) return [];
		const dimensionIds = [...additionalFieldsFilters.map(filter => filter.field?.id), fieldToShow.id];
		return pathOptions.filter(({ value }) => sameDimensions(value, dimensionIds));
	}, [pathOptions, fieldToSet, fieldToShow, additionalFieldsFilters]);
	const comparaisonPathOptions = React.useMemo(() => rowPathOptions
		.filter(({ value }) => value.field_id !== fieldToSet?.id)
		.map(option => ({ ...option, label: fieldsMap.get(option.value.field_id)?.name ?? option.label })), [rowPathOptions, fieldToSet, fieldsMap]);
	const removeRowComparaison = React.useCallback((index: number, color: string) => {
		setRowComparaisons(rowComparaisons => {
			const next = [...rowComparaisons];
			next.splice(index, 1);
			return next;
		});
		setColorsUsedForComparaisons(colors => {
			const next = [...colors];
			const colorIndex = next.indexOf(color);
			if (colorIndex !== -1) next.splice(colorIndex, 1);
			return next;
		});
	}, []);

	const pendingBuildRef = React.useRef(false);
	const fieldIdsToFetch = React.useMemo(() => {
		const ids = new Set<number>();
		if (fieldToSet) ids.add(fieldToSet.id);
		for (const comparaison of colComparaisons) if (comparaison.fieldToSet) ids.add(comparaison.fieldToSet.id);
		for (const comparaison of rowComparaisons) if (comparaison.fieldToSet) ids.add(comparaison.fieldToSet.id);
		return [...ids].sort((a, b) => a - b).join(',');
	}, [fieldToSet, colComparaisons, rowComparaisons]);
	const refresh = React.useCallback(() => {
		const ids = fieldIdsToFetch ? fieldIdsToFetch.split(',').map(Number) : [];
		if (ids.length === 0) {
			setLoadingState(LoadingStateEnum.LOADED);
			return;
		}
		setLoadingState(LoadingStateEnum.LOADING);
		Promise.all(ids.map(id => getAdditionalValues(new URLSearchParams({ path: JSON.stringify({ f: id }) }).toString()))).then(results => {
			pendingBuildRef.current = true;
			setAdditionalValues(results.flat());
		}).catch(() => setLoadingState(LoadingStateEnum.ERROR));
	}, [fieldIdsToFetch]);


	React.useEffect(() => {
		refresh();
	}, [fieldIdsToFetch]);

	React.useEffect(() => {
		if (confirmExport) {
			setLoadingState(LoadingStateEnum.LOADING);
			const filtersToExport = exportDataFiltersList.map((exportData) => {
				const fieldData = exportData.dataList.filter(d => d.checked);
				const res = {
					field: fieldData.length === 1 ? exportData.field : { ...exportData.field, data: fieldData.map(d => d.value.value) },
					fieldValue: fieldData.length === 1 ? fieldData[0].value.value : ''
				};
				return res;
			});
			setTimeout(async() => {
				const exportProducts = sortedProducts.filter(p => {
					if (brandFilter !== undefined && !brandFilter.some(b => b.id == p.brand) && (!emptyBrand || !!p.brand)) return false;
					if (productFilter && !productFilter.all && !productFilter.products.includes(p.id)) return false;
					return !colComparaisons.some(comparaison => comparaison.filterEmptyRows && additionalValuesHashMap.get(pathKey(buildCellPath({ product: p.uuid, staticValues, f: comparaison.fieldToSet?.id }))) == null);
				});
				await exportAssortments(fieldToSet, fieldToShow, filtersToExport, data, exportProducts, filterEmptyRows, allowedValues, staticValues, additionalValuesHashMap);
				setLoadingState(LoadingStateEnum.LOADED);

			}, 0);
			setConfirmExport(false);
			setExportDataFiltersList(getExportDropDownDataByField(additionalFieldsFilters));
		}
	}, [confirmExport]);

	const handleChange = React.useCallback((file: File) => {
		getBase64(file, async loadedFile => {
			let res: PathAndValue[];
			const errors: string[] = [];
			if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
				res = await readXlsxFile(loadedFile).then((rawExcel: any[][]) => rawExcel.reduce<PathAndValue[]>((acc, [path, rawValue], index) => {
					try {
						let value: unknown;
						try {
							value = JSON.parse(rawValue);
						} catch (_) {
							value = rawValue;
						}
						acc.push({
							path: JSON.parse(path),
							value
						});
					} catch (e) {
						errors.push(`${translateToString('line')} ${index + 1}: ${e.message}`);
					}
					return acc;
				}, []));
			} else {
				res = [];
				// TODO accept csv
				//readString(loadedFile, {
				//	complete: (res) => {
				//		console.log(res);
				//	},
				//	worker: true
				//});
			}
			if (res.length == 0) {
				launchToastError(translateToString('assortments.import_no_valid_rows') + (errors.length ? ` — ${errors[0]}` : ''));
				return;
			}
			if (errors.length) launchToastError(translateToString('assortments.import_skipped_rows').replace('{{ COUNT }}', errors.length.toString()) + ` — ${errors[0]}`);
			setLoadingState(LoadingStateEnum.LOADING);
			importAdditionalValues(res).then(refresh);
		});
	}, [refresh]);

	React.useEffect(() => {
		const list: DropdownData[] = [];
		const comparaisonsActive = colComparaisons.length > 0 || rowComparaisons.length > 0;
		list.push(
			{ label: translateToString('import.import_data') + ' (JSON)', value: 1 },
			{ label: translateToString('import.import_data') + ' (Excel)', value: 2 },
			{ label: translateToString('export'), value: 3, disabled: comparaisonsActive, disabledReason: translateToString('assortments.option_disabled_when_comparisons') },
			{ label: 'Recalculer la DN theorique', value: 4 },
			{ label: 'Supprimer tous les champs visibles', value: 5, disabled: comparaisonsActive, disabledReason: translateToString('assortments.option_disabled_when_comparisons') }
		);
		setToolbarOptions(list);
	}, [colComparaisons, rowComparaisons]);

	React.useEffect(() => props.setToolBarState({
		bottomLeftToolbarComponent: <ToolbarBox>
			<ModalLeftToggle isOpen={isModalOpen} onClick={() => setModalOpenByView(open => ({ ...open, [viewMode]: !open[viewMode] }))} />
			{viewMode === 'table' && <ToolbarFilter
				category={AtomCategory.ASSORTMENTS}
				elements={[
					{ kind: ToolbarElement.BRAND_FILTER, withoutBrandOption: true },
					ToolbarElement.PRODUCT_PER_CATEGORY
				]}
			/>}
			{viewMode === 'table' && !!fieldToSet && !!fieldToShow && <FlexDiv gap='8px'>
				<div style={{ fontSize: '12px' }}><Translate id='add' options={{ after: ' :' }} /></div>
				{comparaisonPathOptions.length > 0 && <LocalButton onClick={() => setColComparaisons(t => {
					if (t.some(t => !t.fieldToSet)) return t;
					const color = nextComparaisonColor(colors, colorsUsedForComparaisons);
					if (!color) return t;
					setColorsUsedForComparaisons(c => [...c, color]);
					return [...t, { color, id: Date.now(), filterEmptyRows: false }];
				})}><Translate id='column' /></LocalButton>}
				<LocalButton onClick={() => setRowComparaisons(t => {
					if (!fieldToSet || !fieldToShow) return t;
					const color = nextComparaisonColor(colors, colorsUsedForComparaisons);
					if (!color) return t;
					setColorsUsedForComparaisons(c => [...c, color]);
					return [...t, { filters: structuredClone(additionalFieldsFilters), color, id: Date.now(), fieldToSet: structuredClone(fieldToSet), fieldToShow: structuredClone(fieldToShow), staticValues: structuredClone(staticValues), filterEmptyRows: false }];
				})}><Translate id='line' /></LocalButton>
			</FlexDiv>}
		</ToolbarBox>,
		bottomRightToolbarComponent:
			<ToolbarBox>
				<PageSwitch<AssortmentViewMode>
					background
					selectedValue={viewMode}
					list={[
						{ value: 'list', img: <List />, onClick: setViewMode },
						{ value: 'table', img: <Table />, onClick: setViewMode }
					]}
				/>
				<ToolbarFilter
					category={AtomCategory.ASSORTMENTS}
					elements={[
						ToolbarElement.INPUT_SEARCH
					]}
				/>
				<Dropdown
					datalist={toolbarOptions}
					name='dropdown_actions'
					readOnly
					searchable={false}
					JSXButton={() => (
						<ToolbarImageContainer marginTop='3px'><Ellipsis color={GreySidely3} strokeWidth={2.5} size={18} /></ToolbarImageContainer>
					)}
					dropdownStyle={{
						optionWidth: '200px',
						optionHeight: '140px',
						optionLeft: '-175px'
					}}
					onChange={async(value: DropdownData) => {
						switch (value.value) {
							case 1: {
								const input = document.createElement('input');
								input.type = 'file';
								input.accept = '.xlsx';
								input.onchange = async(e) => {
									const buffer = await (e.target as HTMLInputElement).files![0];
									handleChange(buffer);
								};
								input.click();
								break;
							}
							case 2:
								importMultiDimensionalAssortments(imported => {
									if (!imported) return;
									launchToastMessage(translateToString('import.import_success'));
									refresh();
								}, products, alert, fields.filter(f => f.is_additional));
								break;
							case 3:
								if (fieldToSet)
									setOpenEditExport(true);
								break;
							case 4:
								refreshThericalPresence().then(res => console.log(res.statusText));
								break;
							case 5:
							{

								const path_to_delete = {};
								let path_message = '';
								if (fieldToSet) {
									path_to_delete['f'] = fieldToSet.id;
									path_message += `${fieldToSet.name}`;
								}
								if (fieldToShow) {
									path_to_delete[fieldToShow.id] = '';
									path_message += ` ${translateToString('and')} ${fieldToShow.name}`;
								}
								if (additionalFieldsFilters.length > 0) {
									additionalFieldsFilters.forEach((filter) => {
										if (filter.field) {
											if (filter.fieldValue === undefined) return;
											path_to_delete[filter.field.id] = filter.fieldValue;
											path_message += ` ${translateToString('and')} ${filter.field.name}`;
											if (filter.fieldValue && (typeof filter.fieldValue === 'string' && filter.fieldValue.length > 0) || typeof filter.fieldValue === 'number')
												path_message += ` ${translateToString('equal_to')} ${filter.fieldValue}`;
										}
									});
								}
								if (Object.keys(path_to_delete).length == 0) return;
								setPathToDelete(path_to_delete);
								setPathMessage(path_message);
								setWarningDelete(true);
								break;
							}
							default:
								break;
						}
					}}
				/>
				{/* <Upload
					showUploadList={false}
					name='import'
					onChange={handleChange}
					//@ts-expect-error antd types are wrong
					customRequest={dummyRequest}
					accept='.xlsx'
				>
					<LocalButton><Translate id="import.import_data" /> (JSON)</LocalButton>
				</Upload> */}
			</ToolbarBox>,
		title: translateToString('product.assortments'),
	}), [!!fieldToSet && !!fieldToShow, isModalOpen, viewMode, fieldsMap, additionalFieldsFilters, dataValue, filterEmptyRows, colorsUsedForComparaisons, toolbarOptions, refresh, comparaisonPathOptions, fieldToSet, fieldToShow]);

	const allowedValues = React.useMemo(() => {
		if (fieldToShow === undefined) return undefined;
		return constraintAllowedValues(fieldToShow, staticValues, pinnedFieldsOf(additionalFieldsFilters));
	}, [fieldToShow, staticValues, additionalFieldsFilters]);
	const comparaisonAllowedValues = React.useMemo(() => rowComparaisons.map(comparaison => constraintAllowedValues(comparaison.fieldToShow, comparaison.staticValues, pinnedFieldsOf(comparaison.filters))), [rowComparaisons]);
	const columnValues = React.useMemo(() => {
		if (fieldToShow === undefined || !Array.isArray(fieldToShow.data)) return [];
		const sets = [allowedValues, ...comparaisonAllowedValues];
		return (fieldToShow.data as string[]).filter(value => sets.some(allowed => !allowed || allowed.includes(value)));
	}, [fieldToShow, allowedValues, comparaisonAllowedValues]);

	const getRowClassName = React.useCallback((_, index: number) => {
		const rowComparaisonsLength = isOneRowComparaisonFilterEmpty ? 0 : rowComparaisons.length;
		const adjustedIndex = Math.floor(index / (rowComparaisonsLength + 1));
		return adjustedIndex % 2 === 0 ? '' : 'gradiant1';
	}, [isOneRowComparaisonFilterEmpty, rowComparaisons.length]);

	const productFields: DropdownData<Field>[] = React.useMemo(() => fields.filter(f => f.is_additional).map(f => ({ value: f, label: f.name })), [fields]);
	const fieldToShowData = productFields.filter(f => f.value.id != fieldToSet?.id);

	React.useEffect(() => {
		setData(() => {
			if (additionalFieldsFilters.some(t => !t.field?.id || !t.fieldValue)) return [];
			const lowerInput = inputSearchText.toLocaleLowerCase();
			return sortedProducts.reduce<InnerColumnType[]>((acc, p) => {
				if (brandFilter !== undefined && !brandFilter.some(b => b.id == p.brand) && (!emptyBrand || !!p.brand)) return acc;
				if (productFilter && !productFilter.all && !productFilter.products.includes(p.id)) return acc;
				if (lowerInput && (!p.name.toLocaleLowerCase().includes(lowerInput)) && !p.barcode?.toLocaleLowerCase().includes(lowerInput)) return acc;

				const values: Record<string, unknown> = {};
				// Comparaison columns follow the path of the row they sit on, so a
				// comparaison row reads its own values, not the main row's.
				const colComparaisonsValues = (rowStaticValues: StaticValues) => colComparaisons.map(comparaison => comparaison.fieldToSet
					? additionalValuesHashMap.get(pathKey(buildCellPath({ product: p.uuid, staticValues: rowStaticValues, f: comparaison.fieldToSet.id })))
					: undefined);
				const comparaisonsValues = colComparaisonsValues(staticValues);
				if (colComparaisons.some((comparaison, i) => comparaison.filterEmptyRows && comparaison.fieldToSet && comparaisonsValues[i] == null)) return acc;
				if (fieldToShow === undefined || !Array.isArray(fieldToShow.data)) {
					const oneColCellValue = additionalValuesHashMap.get(pathKey(buildCellPath({ product: p.uuid, staticValues: { f: fieldToSet?.id } })));
					if (filterEmptyRows && isEmptyValue(oneColCellValue)) return acc;
					acc.push({ product: p, values, comparaisonsValues, oneColCellValue, comparaisonIndex: 0 });
					return acc;
				}
				let rowEmpty = true;
				for (const value of (fieldToShow.data as string[]).filter(f => !allowedValues || allowedValues.includes(f))) {
					const newStaticValues = { ...staticValues, f: fieldToSet?.id };
					if (fieldToShow) newStaticValues[fieldToShow.id] = value;
					const path = buildCellPath({ product: p.uuid, staticValues: newStaticValues });
					const additionalValue = additionalValuesHashMap.get(pathKey(path));
					if (!isEmptyValue(additionalValue)) rowEmpty = false;
					values[value] = additionalValue;
				}
				if (filterEmptyRows && rowEmpty) return acc;
				const value = {
					product: p,
					field: fieldToSet,
					values,
					comparaisonsValues,
					comparaisonIndex: 0,
				};
				acc.push(value);
				for (const [index, comparaison] of rowComparaisons.entries()) {
					const comparaisonRowValues: Record<string, unknown> = {};
					let rowEmpty = true;
					const comparaisonAllowed = comparaisonAllowedValues[index];
					for (const value of (comparaison.fieldToShow.data as string[]).filter(f => !comparaisonAllowed || comparaisonAllowed.includes(f))) {
						const newStaticValues = { ...comparaison.staticValues, f: comparaison.fieldToSet?.id };
						if (fieldToShow) newStaticValues[comparaison.fieldToShow.id] = value;
						const path = buildCellPath({ product: p.uuid, staticValues: newStaticValues });
						const additionalValue = additionalValuesHashMap.get(pathKey(path));
						if (!isEmptyValue(additionalValue)) rowEmpty = false;
						comparaisonRowValues[value] = additionalValue;
					}
					if (comparaison.filterEmptyRows && rowEmpty) return acc;
					acc.push({
						product: p,
						field: comparaison.fieldToSet,
						fieldToShow: comparaison.fieldToShow,
						staticValues: comparaison.staticValues,
						values: comparaisonRowValues,
						comparaisonsValues: colComparaisonsValues(comparaison.staticValues),
						dotColor: comparaison.color,
						comparaisonIndex: index + 1,
						mainRow: value,
					});
				}
				return acc;
			}, []);
		});

		if (pendingBuildRef.current) {
			pendingBuildRef.current = false;
			setLoadingState(LoadingStateEnum.LOADED);
		}
	}, [sortedProducts, fieldToSet, inputSearchText, brandFilter, emptyBrand, productFilter, filterEmptyRows, additionalFieldsFilters, colComparaisons, fieldToShow, allowedValues, comparaisonAllowedValues, additionalValuesHashMap, rowComparaisons]);

	const tableColumns = React.useMemo<ColumnType[]>(() => {
		const columns: ColumnType[] = [
			{
				disableSortBy: true,
				disableFilter: true,
				Header: '',
				width: 60,
				id: 'index',
				accessor: (p, i) => {
					const rowComparaisonsLength = isOneRowComparaisonFilterEmpty ? 0 : rowComparaisons.length;
					const adjustedIndex = Math.floor(i / (rowComparaisonsLength + 1)) + 1;
					return <TableRow onClick={() => setProductPopupState({ data: p.product.id, isOpen: true })}>
						<FlexDiv justify='center' gap='4px'>
							{rowComparaisons.length ? <Dot size='15px' color={p.dotColor ?? PrimaryColor} /> : null}
							{isOneRowComparaisonFilterEmpty ? null : <div>{adjustedIndex}</div>}
						</FlexDiv>
					</TableRow>;
				},
			},
			{
				disableSortBy: true,
				disableFilter: true,
				Header: translateToString('name'),
				width: localStorageNameColWidth ?? 300,
				id: 'name',
				accessor: (p) => <TableRowTitle onClick={() => setProductPopupState({ data: p.product.id, isOpen: true })}>{p.product.name}</TableRowTitle>,
				toolTip: (p) => p.product.name,
			},
			{
				disableSortBy: true,
				disableFilter: true,
				id: 'barcode',
				Header: translateToString('EAN-JAN barcode'),
				accessor: (p) => <TableRow>{p.product.barcode}</TableRow>,
				toolTip: (p) => <BarcodeWrapper format={p.product.barcode?.length === 13 ? 'EAN13' : 'EAN8'} value={p.product.barcode ?? ''} width={1} height={70} botMargin='0px' />,
				toolTipStyle: { backgroundColor: SurfaceColor, borderColor: SidelyBlack }
			}];

		if (!!fieldToSet && !fieldToShow)
			columns.push({
				disableFilter: true,
				Header: fieldToSet.name,
				id: 'value-without-field-to-show',
				sortType: () => () => true,
				accessor: p => {
					return <Cell product={p.product} field={fieldToSet} additionalValue={p.oneColCellValue} setAdditionalValues={setAdditionalValues} staticValues={{ f: fieldToSet.id }}
						onEditColDown={(inputValue) => {
							const pathAndValues = getPathAndValuesEditCol(false, inputValue, staticValues, p, data, setLoadingState, additionalValuesHashMapRef.current, fieldToSet.id);
							if (pathAndValues)
								updateBulkEditAndAdditionnalValues(additionalValuesRef.current, pathAndValues, setLoadingState, setAdditionalValues);
						}}
						onEditColDownEmpty={(inputValue) => {
							const pathAndValues = getPathAndValuesEditCol(true, inputValue, staticValues, p, data, setLoadingState, additionalValuesHashMapRef.current, fieldToSet.id);
							if (pathAndValues)
								updateBulkEditAndAdditionnalValues(additionalValuesRef.current, pathAndValues, setLoadingState, setAdditionalValues);
						}}
					/>;
				}
			});

		if (fieldToSet)
			colComparaisons.forEach((comparaison, i) => {
				const comparaisonField = comparaison.fieldToSet;
				columns.push({
					disableSortBy: true,
					disableFilter: true,
					noHeaderEllipsis: true,
					id: `COMPARAISON[${comparaison.id}]`,
					width: 230,
					Header: <FlexDiv gap='5px' width='100%' padding='0 10px'>
						<Dropdown
							dropdownStyle={HeaderDropdownStyle}
							datalist={comparaisonPathOptions}
							selectedValue={comparaisonPathOptions.find(option => option.value.field_id == comparaisonField?.id)}
							placeholder={translateToString('assortments.select_product_field')}
							onChange={v => setColComparaisons(colComparaisons => {
								if (i < colComparaisons.length)
									colComparaisons[i].fieldToSet = v.value ? fieldsMap.get(v.value.field_id) : undefined;
								return [...colComparaisons];
							})}
							name={`ddcolcomparaison[${comparaison.id}]`}
							readOnly />
						<CleanButton
							className="btn btn-transparent p-0"
							type="button"
							onClick={() => {
								setColComparaisons(colComparaisons => {
									const newComparaisons = [...colComparaisons];
									newComparaisons.splice(i, 1);
									return newComparaisons;
								});
								setColorsUsedForComparaisons(colors => {
									const newColors = [...colors];
									const colorIndex = newColors.indexOf(comparaison.color);
									if (colorIndex !== -1) newColors.splice(colorIndex, 1);
									return newColors;
								});
							}}
						>
							<i className="fas fa-times" />
						</CleanButton>
					</FlexDiv>,
					accessor: (p) => {
						if (!comparaisonField) return <TableRow>-</TableRow>;
						const rowStaticValues = p.staticValues ?? staticValues;
						return <Cell
							product={p.product}
							field={comparaisonField}
							staticValues={{ ...rowStaticValues, f: comparaisonField.id }}
							additionalValue={p.comparaisonsValues[i]}
							setAdditionalValues={setAdditionalValues}
							onEditColDown={(inputValue) => {
								const pathAndValues = getPathAndValuesEditCol(false, inputValue, rowStaticValues, p, data, setLoadingState, additionalValuesHashMapRef.current, comparaisonField.id);
								if (pathAndValues)
									updateBulkEditAndAdditionnalValues(additionalValuesRef.current, pathAndValues, setLoadingState, setAdditionalValues);
							}}
							onEditColDownEmpty={(inputValue) => {
								const pathAndValues = getPathAndValuesEditCol(true, inputValue, rowStaticValues, p, data, setLoadingState, additionalValuesHashMapRef.current, comparaisonField.id);
								if (pathAndValues)
									updateBulkEditAndAdditionnalValues(additionalValuesRef.current, pathAndValues, setLoadingState, setAdditionalValues);
							}}
						/>;
					}
				});
			});

		if (!fieldToSet || fieldToShow === undefined || !Array.isArray(fieldToShow.data)) return columns;
		const foundedValues = new Set<string>();
		const rowAllowedValues = (p: InnerColumnType) => p.comparaisonIndex ? comparaisonAllowedValues[p.comparaisonIndex - 1] : allowedValues;
		for (const value of columnValues) {
			if (foundedValues.has(value)) continue;
			foundedValues.add(value);
			columns.push({
				disableFilter: true,
				visualization: true,
				Header: <HeaderContainer>{value}</HeaderContainer>,
				id: `ADDITIONAL_VALUE[${value}]`,
				sortType: () => () => true,
				accessor: (p) => <Cell
					product={p.product}
					field={p.field!}
					additionalValue={p.values[value]}
					setAdditionalValues={setAdditionalValues}
					staticValues={{ ...(p.staticValues ?? staticValues), [p.fieldToShow ? p.fieldToShow.id : fieldToShow.id]: value, f: p.field?.id }}
					onEditColDown={(inputValue) => {
						const pathAndValues = getPathAndValuesEditCol(false, inputValue, p.staticValues ?? staticValues, p, data, setLoadingState, additionalValuesHashMapRef.current, p.fieldToShow ? p.fieldToShow.id : fieldToShow.id, value);
						if (pathAndValues)
							updateBulkEditAndAdditionnalValues(additionalValuesRef.current, pathAndValues, setLoadingState, setAdditionalValues);
					}}
					onEditRowRight={(inputValue) => {
						const pathAndValues = getPathAndValuesEditRow(false, inputValue, p.staticValues ?? staticValues, p.fieldToShow ?? fieldToShow, value, p, rowAllowedValues(p), setLoadingState, additionalValuesHashMapRef.current);
						if (pathAndValues)
							updateBulkEditAndAdditionnalValues(additionalValuesRef.current, pathAndValues, setLoadingState, setAdditionalValues);
					}}
					onEditColDownEmpty={(inputValue) => {
						const pathAndValues = getPathAndValuesEditCol(true, inputValue, p.staticValues ?? staticValues, p, data, setLoadingState, additionalValuesHashMapRef.current, p.fieldToShow ? p.fieldToShow.id : fieldToShow.id, value);
						if (pathAndValues)
							updateBulkEditAndAdditionnalValues(additionalValuesRef.current, pathAndValues, setLoadingState, setAdditionalValues);
					}}
					onEditRowRightEmpty={(inputValue) => {
						const pathAndValues = getPathAndValuesEditRow(true, inputValue, p.staticValues ?? staticValues, p.fieldToShow ?? fieldToShow, value, p, rowAllowedValues(p), setLoadingState, additionalValuesHashMapRef.current);
						if (pathAndValues)
							updateBulkEditAndAdditionnalValues(additionalValuesRef.current, pathAndValues, setLoadingState, setAdditionalValues);
					}}
				/>
			});
		}
		return columns;
	}, [fieldToSet, fieldToShow, staticValues, colComparaisons, allowedValues, comparaisonAllowedValues, columnValues, rowComparaisons, isOneRowComparaisonFilterEmpty, localStorageNameColWidth, productFields, comparaisonPathOptions, fieldsMap]);

	const selectPath = React.useCallback((pathId: number) => {
		setOpenedPathId(pathId);
		setViewMode('list');
	}, []);
	const openCombination = React.useCallback((chain: DimensionValue[]) => {
		if (!openedPath) return;
		setFieldToSet(fieldsMap.get(openedPath.field_id));
		setFieldToShow(chain[chain.length - 1].field);
		setAdditionalFieldsFilters(chain.slice(0, -1).map(({ field, value }) => ({ field, fieldValue: value })));
		setViewMode('table');
	}, [openedPath, fieldsMap]);
	const deleteCombination = React.useCallback((chains: DimensionValue[][]) => {
		if (!openedPath) return Promise.resolve();
		return Promise.all(chains.map(chain => deleteAdditionalValues({ f: openedPath.field_id, ...Object.fromEntries(chain.map(({ field, value }) => [field.id, value])) }, undefined, undefined)))
			.catch(() => launchToastError(translateToString('error_please_retry')))
			.then(() => {
				refresh();
				setViewsLoading(true);
				return getAdditionalValuesViews().then(setViews).catch(console.error).finally(() => setViewsLoading(false));
			});
	}, [openedPath, refresh]);

	return <>
		<AssortmentModalLeft isModalOpen={isModalOpen} paths={paths} views={views} loading={viewsLoading} selectedPathId={openedPath?.id} onSelect={selectPath} />
		{viewMode === 'list' && <FlexDiv flow='column' justify='center' height={`calc(100vh - ${TOOLBARS_HEIGHT + 16}px)`} overflowY='auto' padding='0 16px 16px' margin={isModalOpen ? `0 0 0 ${MODAL_LEFT_WIDTH}px` : undefined}>
			<ComponentLoader loadingState={viewsLoading ? LoadingStateEnum.LOADING : LoadingStateEnum.LOADED} noBackground />
			{!openedPath && !viewsLoading && <NoData message={translateToString('multidimensional_assortments.no_grouping')} height='300px' />}
			{openedPath && <AssortmentFieldPage
				path={openedPath}
				views={views}
				loading={viewsLoading}
				fieldsMap={fieldsMap}
				onOpen={openCombination}
				onDelete={deleteCombination}
			/>}
		</FlexDiv>}
		{viewMode === 'table' && <FlexDiv flow='column' align='stretch' gap='10px' margin={isModalOpen ? `0 0 0 ${MODAL_LEFT_WIDTH}px` : undefined}>
			<FlexDiv flow='column' align='stretch' gap='10px' backgroundColor={BackgroundColor} padding='8px' borderRadius='8px'>
				<FlexDiv width='100%' gap='8px' position='relative'>
					<FlexDiv gap='2px'>
						{rowComparaisons.length ? <Dot size={DOTSIZE} color={PrimaryColor} /> : null}
						<SwitchText>{translateToString('multidimensional_assortments.path_label')}</SwitchText>
					</FlexDiv>
					<FlexDiv flexShrink={0} gap='4px' backgroundColor={SurfaceColor} border={`1px solid ${BorderColor}`} padding='0 5px' height='28px' borderRadius='5px'><Layers3 color={DarkGreySidely2} /><Dropdown dropdownStyle={DropdownStyle} datalist={pathOptions} selectedValue={selectedPath} placeholder={translateToString('multidimensional_assortments.select')} onChange={v => applyPath(v.value)} cancellable name='dd_path' readOnly /></FlexDiv>
					{fieldToSet && <>
						<SwitchText>{translateToString('multidimensional_assortments.i_set')}</SwitchText>
						<FlexDiv flexShrink={0} gap='4px' backgroundColor={PastelPrimaryColor} border={`1px solid ${BorderColor}`} padding='0 5px' height='28px' borderRadius='5px'><Rows3 color={PrimaryColor} /><SwitchText>{fieldToSet.name}</SwitchText></FlexDiv>
					</>}
					{fieldToShow && <>
						<SwitchText>{translateToString('multidimensional_assortments.as_columns')}</SwitchText>
						<FlexDiv flexShrink={0} gap='4px' backgroundColor={PastelPrimaryColor} border={`1px solid ${BorderColor}`} padding='0 5px' height='28px' borderRadius='5px'><Columns3 color={PrimaryColor} /><SwitchText>{fieldToShow.name}</SwitchText></FlexDiv>
					</>}
					<Popup isOpen={warningDelete} popupMode={PopupMode.Centered} onClickOut={() => setWarningDelete(false)} popupStyle={{ height: '200px', width: '400px' }}>
						<FlexDiv justify='center' height='100%' flow='column' gap={'16px'}>
							<div style={{ textAlign: 'center', fontSize: '14px' }}>{translateToString('assortments.warning_delete').replace('{{CONDITION}}', pathMessage)}</div>
							<FlexDiv gap={'8px'}>
								<DefaultButton width={'100px'} onClick={() => setWarningDelete(false)}>{translateToString('cancel')}</DefaultButton>
								<DefaultButton width={'100px'} onClick={() => {
									let colsToDelete: ValuesToDelete = undefined;
									if (fieldToShow && allowedValues && allowedValues.length) {
										colsToDelete = { id: fieldToShow.id.toString(), values: allowedValues };
									}
									else if (fieldToShow && fieldToShow.data && Array.isArray(fieldToShow.data)) {
										colsToDelete = { id: fieldToShow.id.toString(), values: fieldToShow.data };
									}
									deleteAdditionalValues(pathToDelete, colsToDelete, { id: 'p', values: data.current.map(p => p.product.uuid) }).then(() => {
										refresh();
										setWarningDelete(false);
									});
								}} buttonStyle={ButtonStyle.Error}>{translateToString('delete')}</DefaultButton>
							</FlexDiv>
						</FlexDiv>
					</Popup>
					<Popup
						isOpen={openEditExport}
						popupMode={PopupMode.Centered}
						onClickOut={() => {
							setExportDataFiltersList(getExportDropDownDataByField(additionalFieldsFilters));
							setOpenEditExport(false);
						}}
						popupStyle={{ height: '400px', width: '400px' }}
					>
						<FlexDiv align='flex-start' justify='space-between' height='100%' flow='column' fontSize='13px' padding='16px'>
							<FlexDiv flow='column' align='stretch' gap='16px'>
								<div style={{ fontWeight: 'bold', fontSize: '16px' }}><Translate id='assortments.export.export_of_assortment' /></div>
								<FlexDiv flow='column' align='stretch' gap='16px'>
									{fieldToSet &&
										<div><Translate id='assortments.export.export_of_field' /> : <span style={{ fontWeight: 'bold' }}>{fieldToSet.name}</span></div>
									}
									{fieldToShow &&
										<div><Translate id='assortments.export.by' /> <span style={{ fontWeight: 'bold' }}>{fieldToShow.name}</span></div>

									}
									{additionalFieldsFilters.length > 0 && <FlexDiv flow='column' align='stretch'>
										<div><Translate id='assortments.export.with_filters' /> :</div>
										{
											exportDataFiltersList.map(({ field, dataList }, index) => {
												if (!field || !dataList || dataList.length === 0) return null;
												return <FlexDiv key={index} justify='space-between' gap='8px'>
													<span style={{ fontWeight: 'bold' }}>{field.name}</span>
													<Dropdown
														name={field.name}
														datalist={dataList}
														dropdownStyle={{ optionWidth: '250px', optionHeight: '300px', width: '250px' }}
														onChange={(values) => {
															setExportDataFiltersList((prev) => {
																const newList = [...prev];
																const index = newList.findIndex(d => d.field.id === field.id);
																if (index !== -1) {
																	newList[index].dataList.forEach((item) => {
																		item.checked = values.some(v => v.value.fieldId === item.value.fieldId && v.value.value === item.value.value);
																	});
																}
																return newList;
															});
														}}
														checkbox
														checkboxAll
														doNotDeleteOptionOnSelect
														isMulti
													/>
												</FlexDiv>;
											})
										}</FlexDiv>
									}
									<FlexDiv gap='8px'><BoolCheckbox type='checkbox' checked={filterEmptyRows} onClick={() => setFilterEmptyRows((prev) => !prev)} />
										<Translate id='filter_empty_rows' />
									</FlexDiv>
								</FlexDiv>
							</FlexDiv>
							<FlexDiv gap={'8px'} alignSelf='center'>
								<DefaultButton
									width={'100px'}
									buttonStyle={ButtonStyle.White}
									onClick={() => {
										setExportDataFiltersList(getExportDropDownDataByField(additionalFieldsFilters));
										setOpenEditExport(false);
									}}>
									{translateToString('cancel')}
								</DefaultButton>
								<DefaultButton width={'100px'} onClick={() => {
									setConfirmExport(true);
									setOpenEditExport(false);
								}} buttonStyle={ButtonStyle.Default}>
									{translateToString('export')}
								</DefaultButton>
							</FlexDiv>
						</FlexDiv>
					</Popup>
					<Popup
						popupMode={PopupMode.Centered}
						popupStyle={{ height: popupHeight + 'px', overflow: 'auto' }}
						isOpen={popupOpen}
						onClickOut={() => setPopupOpen(false)}
					>
						<Import
							setPopupHeight={setPopupHeight}
							onQuit={() => setPopupOpen(false)}
							onSucess={() => {
								refresh();
								setPopupOpen(false);
							}}
						/>
					</Popup>
				</FlexDiv>
				{fieldToSet && <FlexDiv width='100%' gap='10px'>
					{additionalFieldsFilters.length > 0 && <SwitchText>{translateToString('multidimensional_assortments.for')}</SwitchText>}
					<FilterBuilder
						filters={additionalFieldsFilters}
						setFilters={setAdditionalFieldsFilters}
						fieldToShowData={fieldToShowData}
						productFields={productFields}
						fixedFields
						showAdd={!!fieldToSet && !!fieldToShow}
						filterEmptyRows={filterEmptyRows}
						setFilterEmptyRows={setFilterEmptyRows}
						onClear={() => applyPath(null)}
					/>
					{rowComparaisons.length > 0 ?
						showComparaisons ?
							<RoundButton>
								<Minimize2 color={DarkGreySidely2} onClick={() => setShowComparaisons(false)} />
							</RoundButton> :
							<RoundButton>
								<Maximize2 color={DarkGreySidely2} onClick={() => setShowComparaisons(true)} />
							</RoundButton> : null
					}
				</FlexDiv>}

				{showComparaisons && rowComparaisons.map((comparaison, index) => {
					const highlight = comparaisonHighlight(comparaison.color);
					const fieldDiffers = comparaison.fieldToSet.id !== fieldToSet?.id;
					return <FlexDiv flow='column' align='stretch' gap='10px' key={comparaison.id}>
						<FlexDiv width='100%' gap='8px'>
							<FlexDiv gap='2px'>
								<Dot size={DOTSIZE} color={comparaison.color} />
								<SwitchText>{translateToString('multidimensional_assortments.path_label')}</SwitchText>
							</FlexDiv>
							<FlexDiv flexShrink={0} gap='4px' backgroundColor={fieldDiffers ? highlight : SurfaceColor} border={`1px solid ${BorderColor}`} padding='0 5px' height='28px' borderRadius='5px'><Layers3 color={fieldDiffers ? comparaison.color : DarkGreySidely2} /><Dropdown
								dropdownStyle={fieldDiffers ? { ...DropdownStyle, backgroundColor: highlight } : DropdownStyle}
								datalist={rowPathOptions}
								selectedValue={rowPathOptions.find(option => option.value.field_id === comparaison.fieldToSet.id)}
								placeholder={translateToString('multidimensional_assortments.select')}
								onChange={v => {
									if (!v.value) return removeRowComparaison(index, comparaison.color);
									const comparaisonField = fieldsMap.get(v.value.field_id);
									if (!comparaisonField) return;
									setRowComparaisons(rowComparaisons => {
										const next = [...rowComparaisons];
										next[index] = { ...next[index], fieldToSet: comparaisonField };
										return next;
									});
								}}
								cancellable
								name={`ddrowpath[${comparaison.id}]`}
								readOnly /></FlexDiv>
							<SwitchText>{translateToString('multidimensional_assortments.i_set')}</SwitchText>
							<FlexDiv flexShrink={0} gap='4px' backgroundColor={fieldDiffers ? highlight : PastelPrimaryColor} border={`1px solid ${BorderColor}`} padding='0 5px' height='28px' borderRadius='5px'><Rows3 color={fieldDiffers ? comparaison.color : PrimaryColor} /><SwitchText>{comparaison.fieldToSet.name}</SwitchText></FlexDiv>
							<SwitchText>{translateToString('multidimensional_assortments.as_columns')}</SwitchText>
							<FlexDiv flexShrink={0} gap='4px' backgroundColor={PastelPrimaryColor} border={`1px solid ${BorderColor}`} padding='0 5px' height='28px' borderRadius='5px'><Columns3 color={PrimaryColor} /><SwitchText>{comparaison.fieldToShow.name}</SwitchText></FlexDiv>
						</FlexDiv>
						<FlexDiv width='100%' gap='10px'>
							{comparaison.filters.length > 0 && <SwitchText>{translateToString('multidimensional_assortments.for')}</SwitchText>}
							<FilterBuilder
								filters={comparaison.filters}
								setFilters={t => setRowComparaisons((rowComparaisons) => {
									rowComparaisons[index].filters = t(rowComparaisons[index].filters);
									rowComparaisons[index].staticValues = staticValuesFromFilters(rowComparaisons[index].filters);
									return [...rowComparaisons];
								})}
								filterEmptyRows={comparaison.filterEmptyRows}
								setFilterEmptyRows={b => setRowComparaisons((rowComparaisons) => {
									rowComparaisons[index].filterEmptyRows = b;
									return [...rowComparaisons];
								})}
								fieldToShowData={fieldToShowData}
								productFields={productFields}
								fixedFields
								highlight={{ color: highlight, reference: additionalFieldsFilters }}
								showAdd={true}
								onClear={() => removeRowComparaison(index, comparaison.color)}
							/>
						</FlexDiv>
					</FlexDiv>;
				})}
			</FlexDiv>
			<InfiniteTableStyle noFooter>
				<InfiniteTable
					noFooter
					height={height - (TOOLBARS_HEIGHT + 116 + (showComparaisons ? rowComparaisons.length * (FILTER_HEIGHT + 8) : 0))}
					trackFirstColWidth
					firstColIndex={1}
					pinnedColumns={pinnedUntil}
					onPinColumns={pinColumnsUntil}
					onSort={(tableSort) => {
						const { id, desc } = tableSort ? tableSort : { id: 'default', desc: true };
						let sortFn: ((a: InnerColumnType, b: InnerColumnType, desc: boolean) => number) | undefined;
						if (id === 'default') {
							setData(data => {
								const sorted = [...data].sort((a, b) => {
									const nameA = a.product.name?.toLowerCase() ?? '';
									const nameB = b.product.name?.toLowerCase() ?? '';
									if (nameA < nameB) return desc ? -1 : 1;
									if (nameA > nameB) return desc ? 1 : -1;
									return 0;
								});
								return sorted;
							});
							setSortedProducts([...products].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())));
							return;
						}
						if (id === 'value-without-field-to-show' && !!fieldToSet && !fieldToShow) {
							sortFn = sortCol('', true);
						} else if (id?.startsWith('ADDITIONAL_VALUE[')) {
							const value = id.replace('ADDITIONAL_VALUE[', '').replace(']', '');
							sortFn = sortCol(value, false);
						}
						if (sortFn) {
							const sorted = [...data.current].sort((a, b) => sortFn!(a, b, desc));
							setData(sorted);
						}
					}}
					getClassName={getRowClassName}
					columns={tableColumns}
					data={dataValue} />
			</InfiniteTableStyle>
			<ComponentLoader loadingState={loadingState} allScreen />
			<ProductPopup isOpen={productPopupState.isOpen} setIsOpen={(isOpen) => setProductPopupState({ isOpen })} productId={productPopupState.data} />
		</FlexDiv>}
	</>;
}

function FilterBuilder(props: {
	filters: FieldFilters,
	setFilters: (value: ((prevState: FieldFilters) => FieldFilters)) => void,
	productFields: DropdownData<Field>[],
	fieldToShowData: DropdownData<Field>[],
	showAdd: boolean,
	fixedFields?: boolean,
	highlight?: { color: string, reference: FieldFilters },
	setFilterEmptyRows: (b: boolean) => void
	filterEmptyRows: boolean
	onClear?: () => void
}) {
	const { filters, setFilters, productFields, fieldToShowData, fixedFields, highlight } = props;
	const differsFromReference = (t: FieldFilters[number]) => !!highlight && highlight.reference.find(r => r.field?.id === t.field?.id)?.fieldValue !== t.fieldValue;
	return <>
		{filters.length > 0 && <FlexDiv gap='10px' flow='row wrap'>
			{filters.map((t, myIndex) => {
				// the constraints of the other pinned dimensions narrow the
				// selectable values, exactly like they narrow the displayed
				// columns: an impossible tuple cannot be built
				const siblings = filters.filter((_, i) => i !== myIndex);
				const allowedValues = t.field ? constraintAllowedValues(t.field, staticValuesFromFilters(siblings), pinnedFieldsOf(siblings)) : undefined;
				const saveValue = (v: unknown) => setFilters(t => {
					t[myIndex].fieldValue = v;
					// a changed pin can invalidate sibling pins through the
					// constraints: clear them rather than keeping a tuple the
					// grid would never display
					t.forEach((other, otherIndex) => {
						if (otherIndex === myIndex || !other.field || !other.fieldValue) return;
						const otherSiblings = t.filter((_, i) => i !== otherIndex);
						const allowed = constraintAllowedValues(other.field, staticValuesFromFilters(otherSiblings), pinnedFieldsOf(otherSiblings));
						if (allowed && !allowed.includes(other.fieldValue as string)) other.fieldValue = undefined;
					});
					return [...t];
				});
				return <FlexDiv key={t.field?.id} gap='4px' backgroundColor={differsFromReference(t) ? highlight!.color : SurfaceColor} border={`1px solid ${BorderColor}`} padding='0 5px' flexShrink={0} height='28px' borderRadius='5px'>
					{fixedFields && <>
						<SwitchText>{t.field?.name}</SwitchText>
						<ChipDelimiter />
					</>}
					{!fixedFields && <Select border={false} value={t.field?.id ?? -1} key={t.field?.id} id={`select_additional_fields[${t.field?.id}]`} onChange={e => {
						const parsedId = parseInt(e.target.value);
						const field = productFields.find(f => f.value.id == parsedId)?.value;
						return setFilters(t => {
							if (t[myIndex]?.field?.id == parsedId) return t;
							t[myIndex] = { field, fieldValue: undefined };
							return [...t];
						});
					}}>
						<option disabled value={-1}></option>
						{fieldToShowData.map((v) => (
							<option hidden={filters.some((t) => t.field?.id == v.value.id)} value={v.value.id} key={v.value?.id}>{v.value.name}</option>
						))}
					</Select>}
					{t.field?.id && (t.field.type === 'Select' && Array.isArray(t.field.data)
						? <DimensionSelect
							options={(t.field.data as string[]).filter(v => v !== null && (!allowedValues || allowedValues.includes(v)))}
							value={t.fieldValue}
							backgroundColor={differsFromReference(t) ? highlight!.color : undefined}
							onChange={saveValue}
						/>
						: <RawFieldEditor
							field={t.field}
							value={t.fieldValue}
							inputStyle={{ height: '26px', containerHeight: '26px', hasInputBorder: false, containerBorder: 'none', inputMargin: '0 5px', inputPadding: '0 5px', backgroundColor: differsFromReference(t) ? highlight!.color : undefined }}
							allowedValues={allowedValues}
							onSave={saveValue}
						/>)}

					{!fixedFields && <CleanButton
						className="btn btn-transparent p-0"
						type="button"
						onClick={() => {
							setFilters(t => {
								t.splice(myIndex, 1);
								return [...t];
							});
						}}
					>
						<i className="fas fa-times" />
					</CleanButton>}
				</FlexDiv>;
			})}
		</FlexDiv>}

		{props.showAdd && !fixedFields && <Add onClick={() => setFilters(t => {
			if (t.some(t => !t.field?.id)) return t;
			return [...t, {}];
		})} />}
		<DefaultImage cursor='pointer' src={close} onClick={props.onClear} />
		{props.showAdd && <FlexDiv flexShrink={0} gap='10px'><Switch value={props.filterEmptyRows} onChange={props.setFilterEmptyRows} /> <SwitchText><Translate id='filter_empty_rows' /></SwitchText></FlexDiv>}
	</>;

}

function styleAdditionnalValue(field: Field): 'center' | 'left' | 'right' {
	if (field?.type) {
		switch (field.type) {
			case 'Text':
			case 'Select':
			case 'Url':
			case 'Email':
			case 'Phone':
				return 'left';
			case 'Integer':
			case 'Number':
			case 'Money':
			case 'Date':
			case 'Boolean':
				return 'center';
		}
	}
	return 'center';
}

function buildEditRowArray(path: AdditionalValue[0], value: any, cols: string[], colId: string): PathAndValue[] {
	const res: PathAndValue[] = [];
	cols.map((col) => {
		const newPath = { ...path };
		newPath[colId] = col;
		res.push({ path: newPath, value });
	});
	return res;
}

function buildEditRowEmptyArray(path: AdditionalValue[0], value: any, cols: string[], colId: string, valuesMap: Map<string, unknown>): PathAndValue[] {
	const res: PathAndValue[] = [];
	cols.map((col) => {
		const newPath = { ...path };
		newPath[colId] = col;
		if (valuesMap.get(pathKey(newPath)) != null) return;
		res.push({ path: newPath, value });
	});
	return res;
}

function buildEditColumnArray(path: AdditionalValue[0], value: any, rows: string[]): PathAndValue[] {
	const res = rows.reduce((acc, row) => {
		const newPath = { ...path };
		newPath['p'] = row;
		acc.set(row, { path: newPath, value });
		return acc;
	}, new Map<string, PathAndValue>());
	return [...res.values()];
}

function buildEditColumnEmptyArray(path: AdditionalValue[0], value: any, rows: string[], valuesMap: Map<string, unknown>): PathAndValue[] {
	const res = rows.reduce((acc, row) => {
		const newPath = { ...path };
		newPath['p'] = row;
		if (valuesMap.get(pathKey(newPath)) != null) return acc;
		acc.set(row, { path: newPath, value });
		return acc;
	}, new Map<string, PathAndValue>());
	return [...res.values()];
}

function Cell({ product, staticValues, setAdditionalValues, readonly, additionalValue, field, onEditRowRight, onEditColDown, onEditRowRightEmpty, onEditColDownEmpty }: { field: Field, product: Product, staticValues: StaticValues, setAdditionalValues?: React.Dispatch<React.SetStateAction<AdditionalValue[]>>, readonly?: boolean, additionalValue: any, onEditRowRight?: (value: any) => void, onEditColDown?: (value: any) => void, onEditRowRightEmpty?: (value: any) => void, onEditColDownEmpty?: (value: any) => void }) {
	const [loadingState, setLoadingState] = React.useState<LoadingStateEnum>(LoadingStateEnum.LOADED);
	const [isActive, setIsActive] = React.useState(false);
	const [inputValue, setInputValue] = React.useState(additionalValue);
	const justify = styleAdditionnalValue(field);
	const cellRef = React.useRef<HTMLDivElement>(null);
	const [anchor, setAnchor] = React.useState<DOMRect>();
	const [actionsRef, actionsStyle] = useClampToViewport(isActive);
	const fieldsWithoutClickOutside = ['Multiselect', 'Date', 'TextArea', 'Boolean'];

	React.useEffect(() => {
		if (!isActive || (field.type && !fieldsWithoutClickOutside.includes(field.type))) return;

		const handleClickOutside = (event: MouseEvent) => {
			const target = event.target as Node;
			if (cellRef.current && !cellRef.current.contains(target) && !actionsRef.current?.contains(target)) {
				setIsActive(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [isActive, field?.type]);

	const handleBlur = React.useCallback(() => {
		if (field.type && !fieldsWithoutClickOutside.includes(field.type)) {
			setIsActive(false);
		}
	}, [field?.type]);

	if (loadingState === LoadingStateEnum.LOADING) return <Loader width='15px' />;
	if (readonly) return <TableRow>{additionalValue}</TableRow>;
	if (isActive) {
		return <div style={{ width: '100%', height: '40px' }} ref={cellRef}>
			<TableRow overflow={field.type === 'Multiselect' ? 'visible' : 'hidden'} onBlur={handleBlur}>
				<RawFieldEditor
					field={field}
					value={additionalValue}
					autoFocus
					searchableMultiselect={false}
					inputStyle={field.type === 'Multiselect' ? { margin: '-7px 0 0 0', optionWidth: '135px', optionHeight: '200px', width: '130px' } : { margin: '-7px 0 0 0' }}
					onChange={v => setInputValue(v)}
					popupForBigFields
					boolButtonNullOption
					onSave={vRaw => {
						const v = vRaw === '' ? null : vRaw;
						setInputValue(v);
						const path = buildCellPath({ product: product.uuid, staticValues });
						setLoadingState(LoadingStateEnum.LOADING);
						saveAdditionalValue(path, v).then(() => {
							setLoadingState(LoadingStateEnum.LOADED);
							setAdditionalValues?.(av => {
								const ref = findAdditionalValueRef(path, av);
								if (ref) ref[1] = v;
								else av.push([path, v]);
								return [...av];
							});
						}).catch(() => setLoadingState(LoadingStateEnum.ERROR));
					}} />
			</TableRow>
			{anchor && ReactDOM.createPortal(<OnFocusInputContainer
				isFocused={isActive}
				innerRef={(node: HTMLDivElement | null) => (actionsRef as React.MutableRefObject<HTMLDivElement | null>).current = node}
				style={{ position: 'fixed', zIndex: 30, top: anchor.top + anchor.height / 2, left: anchor.right, ...actionsStyle }}
			>
				{onEditColDown &&
					<InlineButton minHeight='40px' backgroundColor={PastelPrimaryColor} onMouseDown={() => {
						onEditColDown(inputValue);
					}}>
						<Translate id='assortments.apply_to_column' />
					</InlineButton>
				}
				{onEditRowRight &&
					<InlineButton minHeight='40px' backgroundColor={PastelPrimaryColor} onMouseDown={() => {
						onEditRowRight(inputValue);
					}}>
						<Translate id='assortments.apply_to_row' />
					</InlineButton>
				}
				{onEditColDownEmpty &&
					<InlineButton minHeight='40px' backgroundColor={PastelPrimaryColor} onMouseDown={() => {
						onEditColDownEmpty(inputValue);
					}}>
						<Translate id='assortments.apply_to_empty_column' />
					</InlineButton>
				}
				{onEditRowRightEmpty &&
					<InlineButton minHeight='40px' backgroundColor={PastelPrimaryColor} onMouseDown={() => {
						onEditRowRightEmpty(inputValue);
					}}>
						<Translate id='assortments.apply_to_empty_row' />
					</InlineButton>
				}
			</OnFocusInputContainer>, document.body)}
		</div>;
	}
	else {
		let valueToDisplay = '-';
		if (additionalValue !== null && additionalValue !== undefined) {
			switch (field.type) {
				case 'Money':
					valueToDisplay = (additionalValue / 100).toFixed(2);
					break;
				case 'Multiselect':
					valueToDisplay = Array.isArray(additionalValue) ? additionalValue.length > 0 ? additionalValue.join(', ') : '-' : additionalValue;
					break;
				case 'Date':
					valueToDisplay = moment(additionalValue).format('L LT');
					break;
				case 'Boolean':
					valueToDisplay = translateToString(additionalValue ? 'yes' : 'no');
					break;
				default:
					valueToDisplay = additionalValue.toString();
			}
		}
		return <TableRow onClick={e => {
			setAnchor(e.currentTarget.getBoundingClientRect());
			setIsActive(true);
		}}>
			<AdditionnalValueStyle justify={justify} title={valueToDisplay}>
				{valueToDisplay}
			</AdditionnalValueStyle>
		</TableRow>;
	}
}

interface SimpleSelectProps {
	options: string[];
	value?: string;
	emptiable?: boolean;
	onChange?: (value: string) => void;
}

function SimpleSelect({ options, value, onChange, emptiable }: SimpleSelectProps) {
	return <select value={value} defaultValue={value === undefined ? '' : undefined} onChange={e => onChange?.(e.target.value)}>
		<option disabled={!emptiable} value=""></option>
		{options.map(o => <option key={o} value={o}>{o}</option>)}
	</select>;
}

type Fields = Map<number, Field>;

interface ImportProps {
	onSucess: () => void;
	setPopupHeight?: (height: number) => void;
	onQuit: () => void;
}


function validateEmail(email: string): boolean {
	return Boolean(
		String(email)
			.toLowerCase()
			.match(
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
			),
	);
}

function validatePhone(phone: string): boolean {
	return Boolean(String(phone).match(/^(\+?\d{1,3}[- ]?)?(\d{3}[- ]?){2}\d{3}$/));
}

const ExcelBooleans = ['true', 'True', 'TRUE', 'Vrai', 'vrai', 'VRAI', '1', 'V', 'v', 'Oui', 'oui', 'OUI', 'Y', 'y', 'Yes', 'yes', 'YES', 'X', 'x', 'O', 'o', 'On', 'on', 'ON', 'S', 's', 'Si', 'si', 'SI', 'J', 'j', 'Ja', 'ja', 'JA', 'T', 't', 'Yup', 'yup', 'YUP', 'Okey', 'okey', 'OKEY'];

export function doParseValue(type: FieldType, value: unknown): string | number | boolean | null | undefined | string[] {
	switch (type) {
		case 'Select':
		case 'Text': {
			if (typeof value !== 'string') value = value?.toString();
			if (typeof value !== 'string') return null;
			return value.trim() !== '' ? value : null;
		}
		case 'User':
		case 'Integer': {
			if (typeof value === 'number') return value;
			if (value === undefined || value === null) return null;
			const valueS = value.toString();
			return valueS.trim() !== '' ? parseInt(valueS) : null;
		}
		case 'Number': {
			if (typeof value === 'number') return value;
			if (value === undefined || value === null) return null;
			const valueS = value.toString();
			return valueS.trim() !== '' ? parseFloat(valueS) : null;
		}
		case 'Boolean': {
			if (typeof value === 'boolean') return value;
			if (typeof value === 'number') return !!value;
			if (value === undefined || value === null) return null;
			const valueS = value.toString();
			return ExcelBooleans.includes(valueS.trim());
		}
		case 'Money': {
			if (value === undefined || value === null) return null;
			if (typeof value === 'string' && value.trim() === '') return null;
			const valueFloat = typeof value === 'number' ? value : parseFloat(value.toString());
			return Math.round(valueFloat * 100);
		}
		case 'Date':
			if (typeof value !== 'string' && typeof value !== 'number') return null;
			try {
				return (new Date(value)).toUTCString();
			} catch {
				return null;
			}
		case 'Url': {
			if (value === undefined || value === null) return null;
			const url = new URL(value.toString());
			return url.toString();
		}
		case 'Email': {
			if (value === undefined || value === null) return null;
			const valueS = value.toString();
			assert(validateEmail(valueS), 'Invalid email');
			return valueS;
		}
		case 'Phone': {
			if (value === undefined || value === null) return null;
			const valueS = value.toString();
			assert(validatePhone(valueS), 'Invalid phone');
			return valueS;
		}
		case 'Multiselect': {
			if (value === undefined || value === null) return null;
			if (isArray(value)) return value.map(v => v?.toString().trim());
			const valueS = value.toString();
			return valueS.trim() !== '' ? valueS.split(',').map(v => v.trim()) : null;
		}
	}
}


function Import({ onSucess, setPopupHeight, onQuit }: ImportProps) {
	const [sheet, setSheet] = React.useState<any>();
	const [productColumn, setProductColumn] = React.useState<string>();
	const [staticValues, setStaticValues] = React.useState<[number, string][]>();
	const [valuesToSet, setValuesToSet] = React.useState<[number, string][]>();
	const [step, setStep] = React.useState<number>(0);
	const nextDisabled = step == 0 && !productColumn || step == 1 && (staticValues && staticValues.some(([, r]) => !r)) || (valuesToSet && valuesToSet.some(([, r]) => !r));
	const fieldsAtom = useRecoilValue(AFormFields);
	const keepEmpty = React.useRef(false);
	const reset = () => { setSheet(undefined); setProductColumn(undefined); setStaticValues(undefined); setValuesToSet(undefined); setStep(0); };
	const products = useRecoilValue(AProducts);
	const [filename, setFilename] = React.useState<string | undefined>(undefined);

	const fields = React.useMemo(() => {
		return new Map(fieldsAtom.map(f => [f.id, f]));
	}, [fieldsAtom]);


	if (step >= 2) {
		setPopupHeight?.(400);
	} else if (step >= 1) {
		setPopupHeight?.(350);
	} else if (sheet) {
		setPopupHeight?.(250);
	} else {
		setPopupHeight?.(230);
	}

	return <FlexDiv flow='column' gap='10px' style={{ paddingTop: '40px' }}>
		<>
			<div>
				{sheet ? filename : translateToString('choose_file')}
				<DefaultButton disabled={(sheet !== undefined)} onClick={() => {
					if (sheet) {
						return;
					}
					const input = document.createElement('input');
					input.type = 'file';
					input.accept = '.xlsx';
					input.onchange = async(e) => {
						const target = e.target! as HTMLInputElement;
						const buffer = await target.files![0].arrayBuffer();
						const workbook = XLSX.read(new Uint8Array(buffer), { type: 'array' });
						const sheet = workbook.Sheets[workbook.SheetNames[0]];
						setFilename(target.files![0].name);
						setSheet(XLSX.utils.sheet_to_json(sheet));
					};
					input.click();
				}}>{translateToString('import_')}</DefaultButton>
			</div>
		</>

		{step == 0 && <ImportStepProduct sheet={sheet} productColumn={productColumn} setProductColumn={setProductColumn} />}
		{step == 1 && <ImportStepStaticValues sheet={sheet} productColumn={productColumn!} staticValues={staticValues ?? []} setStaticValues={setStaticValues} />}
		{step == 2 && <ImportStepValuesToSet sheet={sheet} productColumn={productColumn!} staticValues={staticValues ?? []} valuesToSet={valuesToSet ?? []} setValuesToSet={setValuesToSet} keepEmpty={keepEmpty} />}
		<div className="flex flex-row justify-between">

			{step == 0 ? <DefaultButton type="button" onClick={onQuit}>
				{translateToString('cancel')}
			</DefaultButton> : <DefaultButton type="button" onClick={() => setStep(step - 1)}>
				{translateToString('back')}
			</DefaultButton>}

			<DefaultButton
				disabled={nextDisabled}
				type="submit"
				onClick={() => {
					if (step == 2) {
						doImport(sheet, fields, productColumn!, staticValues, valuesToSet!, keepEmpty.current, products)
							.catch(e => {
								console.error(e);
								launchToastError(e.toString());
							})
							.then(() => {
								onSucess();
								reset();
							});
					} else {
						setStep(step + 1);
					}
				}}
			>
				{step == 2 ? translateToString('import_') : translateToString('next')}
			</DefaultButton>
		</div>
	</FlexDiv>;
}

function ImportStepProduct({ sheet, productColumn, setProductColumn }: { sheet: any, productColumn?: string, setProductColumn: (v: string) => void }) {
	return <>
		{sheet && <FlexDiv flow='row' gap='10px'>
			<span>{translateToString('import.choose_product_column')}</span><SimpleSelect value={productColumn} options={sheet ? Object.keys(sheet[0]) : []} onChange={setProductColumn} />
		</FlexDiv>}
	</>;
}

function ImportStepStaticValues({ sheet, productColumn, staticValues, setStaticValues }: { sheet: any, staticValues: [number, string][], productColumn: string, setStaticValues: (v: [number, string][]) => void }) {
	const fields = useRecoilValue(AFormFields);

	const fieldMap = useMemo(() => new Map(fields.map(f => [f.id, f])), [fields]);

	return <>
		{sheet && <>
			<div>{translateToString('import.choose_static_values')}</div>
			<FlexDiv flow='column' gap='10px'>
				{
					staticValues.map(([l, r], i) => <FlexDiv key={i} flow='row' gap='10px'>
						<SimpleSelect key={`a${i}`} value={fieldMap.get(l)?.name} options={fields.filter(f => f.is_additional).map(f => f.name)} onChange={v => setStaticValues([...staticValues.slice(0, i), [fields.find((f) => f.name == v)!.id!, r], ...staticValues.slice(i + 1)])} />
						<SimpleSelect key={`b${i}`} value={r} options={Object.keys(sheet[0]).filter(c => c != productColumn)} onChange={v => setStaticValues([...staticValues.slice(0, i), [l, v], ...staticValues.slice(i + 1)])} />
						<Delete src={deleteImage} onClick={() => {
							setStaticValues([...staticValues.slice(0, i), ...staticValues.slice(i + 1)]);
						}} />
					</FlexDiv>)
				}
			</FlexDiv>
			<div className="flex flex-row justify-center">
				<Add onClick={() => {
					setStaticValues([...staticValues, [fields.filter((f) => f.is_additional)[0]?.id ?? 0, '']]);
				}} />
			</div>
		</>}
	</>;
}

function ImportStepValuesToSet({ sheet, productColumn, staticValues, valuesToSet, setValuesToSet, keepEmpty }: { sheet: any, staticValues: [number, string][], valuesToSet: [number, string][], productColumn: string, setValuesToSet: (v: [number, string][]) => void, keepEmpty: React.MutableRefObject<boolean> }) {
	const fields = useRecoilValue(AFormFields);

	const fieldsMap = useMemo(() => new Map(fields.map(f => [f.id, f])), [fields]);

	return <><div>{translateToString('import.choose_values_to_import')}</div>
		<FlexDiv flow='column' gap='10px'>
			{
				valuesToSet.map(([l, r], i) => <FlexDiv key={i} flow='row' gap='10px'>
					<SimpleSelect key={i + valuesToSet.length} value={fieldsMap.get(l)?.name ?? ''} options={fields.filter((f) => f.is_additional && !staticValues.map(s => s[0]).includes(f.id)).map((f) => f.name)} onChange={v => setValuesToSet([...valuesToSet.slice(0, i), [fields.find((f) => f.name == v)!.id, r], ...valuesToSet.slice(i + 1)])} />
					<SimpleSelect key={i} value={r} options={Object.keys(sheet[0]).filter(c => c != productColumn && !staticValues.map(s => s[1]).includes(c))} onChange={v => setValuesToSet([...valuesToSet.slice(0, i), [l, v], ...valuesToSet.slice(i + 1)])} />
					<Delete src={deleteImage} onClick={() => {
						setValuesToSet([...valuesToSet.slice(0, i), ...valuesToSet.slice(i + 1)]);
					}} />
				</FlexDiv>)
			}
		</FlexDiv>
		<div className="flex flex-row justify-center">
			<Add onClick={() => setValuesToSet([...valuesToSet, [fields.filter((f) => f.is_additional && !staticValues.map(s => s[0]).includes(f.id))[0][0] ?? 0, '']])} />
		</div>
		<label className="text-sm flex items-center">{translateToString('import.keep_empty')}<input className="m-2" type="checkbox" onChange={e => keepEmpty.current = e.target.checked} /></label>
	</>;
}

async function doImport(sheet: Record<string, any>[], fields: Fields, productColumn: string, staticValues: [number, string][] | undefined, valuesToSet: [number, string][], keepEmpty: boolean, products: Product[]): Promise<null> {
	const additionalValues = sheet.flatMap(row => {
		const pUuid = products.find(p => p.name == row[productColumn])?.uuid;
		if (!validate(pUuid)) {
			throw new Error(`Invalid product: "${row[productColumn]}" at row ${row.__rowNum__} column "${productColumn}"`);
		}
		const path: Record<number | string, any> = { p: pUuid };
		if (staticValues) {
			for (const [f, r] of staticValues) {
				const field = fields.get(f);
				assert(field, `Field ${f} is undefined`);
				try {
					path[f] = doParseValue(field.type, row[r].toString());
				} catch (e: any) {
					throw new Error(`Invalid value "${row[r]}" for field "${field.name}" at row ${row.__rowNum__} column "${r}": ${e}`);
				}
				if (path[f] === undefined) {
					throw new Error(`Invalid value "${row[r]}" for field "${field.name}" at row ${row.__rowNum__} column "${r}"`);
				}
			}
		}

		return valuesToSet.reduce((acc, [f, r]) => {
			const field = fields.get(f)!;
			try {
				if (row[r] === undefined && !keepEmpty) {
					return acc;
				} else if (row[r] === undefined && keepEmpty) {
					acc.push({ path: { ...path, f }, value: null });
					return acc;
				}
				const value = doParseValue(field.type, row[r].toString());
				if (value === undefined && !keepEmpty) {
					return acc;
				}
				acc.push({ path: { ...path, f }, value });
				return acc;
			} catch (e: any) {
				throw new Error(`Invalid value "${row[r]}" for field "${field.name}" at row ${row.__rowNum__} column "${r}": ${e}`);
			}
		}, [] as PathAndValue[]);
	});
	return await importAdditionalValues(additionalValues);
}
